// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__KXuF7","title":"ClientReferral_title__172Bh","itemText":"ClientReferral_itemText__MtBJW"};